import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { GoalsSection } from '../components/GoalsSection';
import { TemplatesCarousel } from '../components/TemplatesCarousel';
import { KitContentsSection } from '../components/KitContentsSection';
import { ResultsSection } from '../components/ResultsSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function LandingPage() {
  return <main className="w-full overflow-hidden" data-id="element-257">
      <HeroSection data-id="element-258" />
      <ProblemSection data-id="element-259" />
      <GoalsSection data-id="element-260" />
      <TemplatesCarousel data-id="element-261" />
      <KitContentsSection data-id="element-262" />
      <ResultsSection data-id="element-263" />
      <BeforeAfterSection data-id="element-264" />
      <OfferSection data-id="element-265" />
      <GuaranteeSection data-id="element-266" />
      <FinalCtaSection data-id="element-267" />
    </main>;
}